// src/lib/authConfig.js
export const msalConfig = {
  auth: {
    clientId:   process.env.REACT_APP_MSAL_CLIENT_ID,
    authority:  process.env.REACT_APP_MSAL_AUTHORITY,       // e.g. https://login.microsoftonline.com/<your-tenant-id>
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,    // e.g. http://localhost:3000
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Calendars.ReadWrite"],
};
